import { ReactComponent as TextIncreaseIcon } from "../../../../icons/text_increase.svg";
import { ReactComponent as AutoModeIcon } from "../../../../icons/auto_mode.svg";
import { ReactComponent as DeleteIcon } from "../../../../icons/delete.svg";
import { ReactComponent as VisibilityIcon } from "../../../../icons/visibility.svg";
import { ReactComponent as CalculateIcon } from "../../../../icons/calculate.svg";
import { CollectiveActionType } from './types/collectiveActionType';
import { CollectiveIconsProps } from "./types/collectiveIconsProps";

const CollectiveIcons = (props: CollectiveIconsProps) => {

    const onPreviewClick = () => {
        if (props.fillCount > 0) {
            props.onPreview(true);
        }
    }

    const prepareIconClassName = (selected: boolean, active: boolean) => {
        if (selected) return "collective-action-selected";
        if (active) return "collective-action-active";
        return "collective-action";
    }

    const setActionType = (actionType: CollectiveActionType) => {
        if (props.actionType === actionType) {
            props.onActionChange(null);
        } else {
            if (actionType === CollectiveActionType.Delete) {
                if (!props.disabledDelete && !props.hasValue) {
                    props.onActionChange(actionType);
                }
            } else {
                if (props.hasValue) {
                    if (!props.disableAdd && actionType === CollectiveActionType.Add) {
                        props.onActionChange(actionType);
                    } else if (!props.disableOverwrite && actionType === CollectiveActionType.Overwrite) {
                        props.onActionChange(actionType);
                    }
                }
            }
        }
    }

    const isNotChecked = () => {
        if (props.hideInfo) {
            return false;
        }
        const isActionEmpty = props.actionType === null || props.actionType === undefined;
        if (isActionEmpty) {
            return props.hasValue;
        }
        return false;
    }

    return (<div className={`collective-actions-row${props.top ? " collective-actions-top" : ""}`}>
        {isNotChecked() && <div className='collective-actions-row-info'>Proszę wybrać jedną z opcji</div>}
        <TextIncreaseIcon className={prepareIconClassName(CollectiveActionType.Add === props.actionType, !props.disableAdd && props.hasValue)} title='dopisz' onClick={() => { setActionType(CollectiveActionType.Add) }} />
        <AutoModeIcon className={prepareIconClassName(CollectiveActionType.Overwrite === props.actionType, !props.disableOverwrite && props.hasValue)} title='nadpisz' onClick={() => { setActionType(CollectiveActionType.Overwrite) }} />
        <DeleteIcon className={prepareIconClassName(CollectiveActionType.Delete === props.actionType, !props.disabledDelete && !props.hasValue)} title='usuń' onClick={() => { setActionType(CollectiveActionType.Delete) }} />
        <VisibilityIcon className={prepareIconClassName(false, props.fillCount > 0)} title='zobacz' onClick={onPreviewClick} />
        <CalculateIcon className={prepareIconClassName(false, props.fillCount > 0)} title={`Pole uzupełnione dla ${props.fillCount ? props.fillCount : 0} kart`} />
    </div>)
}

export default CollectiveIcons;